import { type I18NLocale } from './Locale.types';
import { isI18NLocale } from './typeGuards';

export function filterKeysByTimeOfDay(inputs: readonly string[]): string[];
export function filterKeysByTimeOfDay(inputs: I18NLocale[]): I18NLocale[];

export function filterKeysByTimeOfDay<T extends string[] | I18NLocale[]>(inputs: T): T {
    const hours = new Date().getHours();
    if (hours >= 3 && hours < 12) return inputs.filter(input => !getKey(input).match(/afternoon|evening/)) as T;
    if (hours >= 12 && hours < 17) return inputs.filter(input => !getKey(input).match(/morning|evening/)) as T;
    return inputs.filter(input => !getKey(input).match(/morning|afternoon/)) as T;
}

function getKey(input: string | I18NLocale): string {
    return isI18NLocale(input) ? input.key : input;
}
